import createNamespaceContext from './helper/createNamespaceContext';
export const POST_OFFICE_CONTEXT = 'postOfficeCtx';
export const PostOfficeAnalyticsContext = createNamespaceContext(POST_OFFICE_CONTEXT, 'PostOfficeAnalyticsContext');